export default "__VITE_ASSET__DKOpx87U__"